import React, { useState } from "react";
import { Box, Container, makeStyles } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { apiEndpoints, apiPostRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import KmPageTitle from "src/components/layout/KmPageTitle";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const ContactForm = ({
  systemInfo,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [sendingSuccess, setSendingSuccess] = useState(false);

  let pageTitle = "Kontakt";

  const onSubmit = (formValues, copySend, attachments) => {
    enableGlobalLoader();

    apiPostRequest(
      apiEndpoints.sendContactEmail.path,
      {
        subject: formValues.subject,
        body: formValues.body,
        sendCopy: copySend,
        attachments: attachments.map((attachment) => {
          return {
            attachmentFile: {
              fileName: attachment.resName,
              fileData: attachment.fileData.data,
            },
          };
        }),
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 3000,
          message: "Wiadomość została wysłana",
        });
        setSendingSuccess(true);
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>{pageTitle}</KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form displaySnackbar={displaySnackbar} onSubmit={onSubmit} sendingSuccess={sendingSuccess}/>
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  systemInfo: state.globalData.systemInfo,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
